(() => {
  'use strict';
  if (window.AWEcosystemP1Copy?.version) return;

  const normalize = (value = '') => String(value || '').trim().toLowerCase().normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').replace(/&/g, ' et ').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const modelNodes = () => Array.from(document.querySelectorAll('[data-aw-tool-model],[data-aw-model-context-model]'));
  const counts = () => {
    const technical = new Set(modelNodes().map((node) => [
      normalize(node.dataset.manufacturer), normalize(node.dataset.model),
      normalize(node.dataset.platform), normalize(node.dataset.type)
    ].join('|')).filter((value) => value.replace(/\|/g, ''))).size;
    const dedicated = new Set(modelNodes().map((node) => String(node.dataset.pageUrl || '').trim()).filter(Boolean)).size;
    return { technical, dedicated };
  };
  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const activeReplica = () => window.AWEcosystemP1Bridge?.activeReplica?.() || null;
  const exactRecord = (replica = activeReplica()) => {
    if (!replica || !window.AWEcosystemP1Bridge?.resolveExactModel) return null;
    return window.AWEcosystemP1Bridge.resolveExactModel(replica);
  };

  const currentExactRecord = () => {
    const bridge = window.AWEcosystemP1Bridge;
    if (!bridge?.resolveExactModel) return null;
    let context = null;
    try { context = window.AWAirsoftContext?.current?.() || JSON.parse(localStorage.getItem('aw_airsoft_context_v1') || '{}'); }
    catch (_) { context = null; }
    if (!context?.model) return null;
    return bridge.resolveExactModel({
      manufacturer: context.manufacturerLabel || context.manufacturer || '',
      model: context.model || '',
      platform: context.platform || '',
      type: context.type || context.replicaType || ''
    });
  };

  const buildLink = (label, href, className = 'aw-ecosystem-p1-link') => {
    const link = document.createElement('a');
    link.href = href;
    link.className = className;
    link.textContent = label;
    return link;
  };

  const compatibilityTarget = (replica, record) => {
    if (record?.pageUrl) return record.pageUrl;
    if (window.AWEcosystemP1Bridge?.compatibilityUrl) return window.AWEcosystemP1Bridge.compatibilityUrl(replica);
    return '/pages/compatibilite-airsoft';
  };

  const renderMonAtelierStatus = () => {
    const root = document.querySelector('[data-aw-atelier]');
    if (!root) return;
    const page = root.querySelector('.page-width');
    const hero = root.querySelector('.aw-atelier__hero');
    if (!page || !hero) return;

    let panel = root.querySelector('[data-aw-ecosystem-mon-atelier-status]');
    if (!panel) {
      panel = document.createElement('aside');
      panel.dataset.awEcosystemMonAtelierStatus = 'true';
      panel.className = 'aw-ecosystem-p1-context';
      hero.insertAdjacentElement('afterend', panel);
    }

    const replica = activeReplica();
    const record = exactRecord(replica);
    panel.replaceChildren();

    const copy = document.createElement('div');
    copy.className = 'aw-ecosystem-p1-context__copy';
    const eyebrow = document.createElement('span');
    eyebrow.className = 'aw-ecosystem-p1-context__eyebrow';
    eyebrow.textContent = 'DOSSIER TECHNIQUE AW';
    const title = document.createElement('strong');
    title.className = 'aw-ecosystem-p1-context__title';
    const meta = document.createElement('span');
    meta.className = 'aw-ecosystem-p1-context__meta';

    const actions = document.createElement('div');
    actions.className = 'aw-ecosystem-p1-context__actions';

    if (!replica) {
      title.textContent = 'Aucune réplique Garage active';
      meta.textContent = 'Activez une réplique dans AW Garage pour relier son dossier à Compatibility et aux prestations Atelier déjà enregistrées.';
      actions.append(buildLink('Voir AW Garage', '/pages/mon-atelier-airsoft'));
    } else {
      const label = [replica.manufacturer, replica.model].filter(Boolean).join(' ').trim() || replica.nickname || 'Réplique Garage';
      title.textContent = label;
      const details = [
        replica.platform ? `Plateforme : ${replica.platform}` : '',
        replica.type ? `Type : ${replica.type}` : ''
      ].filter(Boolean);

      if (record) {
        details.push('Modèle exact AW reconnu');
        details.push(record.pageUrl ? 'Fiche Compatibility dédiée disponible' : 'Base technique sans fiche dédiée');
        const count = Array.isArray(record.workshopServices) ? record.workshopServices.length : 0;
        details.push(count
          ? `${count} prestation${count > 1 ? 's' : ''} Atelier explicitement liée${count > 1 ? 's' : ''}`
          : 'Aucune prestation Atelier spécifique enregistrée');
      } else {
        details.push('Modèle exact AW non reconnu automatiquement');
      }
      meta.textContent = details.join(' · ');

      actions.append(
        buildLink(record?.pageUrl ? 'Ouvrir la fiche Compatibility' : 'Vérifier dans Compatibility', compatibilityTarget(replica, record)),
        buildLink('Consulter l’Atelier', '/pages/notre-atelier-de-preparation-de-repliques-airsoft#aw-atelier-prestations')
      );
    }

    copy.append(eyebrow, title, meta);
    panel.append(copy, actions);
  };

  const enforceAtelierExactPriority = () => {
    const root = document.querySelector('#aw-atelier-hub');
    if (!root) return;
    const record = exactRecord();
    if (!record?.workshopServices?.length) return;
    root.querySelectorAll('.aw14-card[data-aw-workshop-match="type"]').forEach((card) => {
      card.classList.remove('is-aw-active-service');
      delete card.dataset.awWorkshopMatch;
      card.querySelectorAll('[data-aw-active-service-note]').forEach((note) => note.remove());
    });
  };

  const renderAtelierRelationStatus = () => {
    const root = document.querySelector('#aw-atelier-hub');
    if (!root) return;
    const replica = activeReplica();
    const record = exactRecord(replica);
    let note = root.querySelector('[data-aw-ecosystem-atelier-relation-status]');
    if (!replica || !record) { note?.remove(); return; }
    const handles = Array.isArray(record.workshopServices) ? record.workshopServices.filter(Boolean) : [];
    if (!note) {
      note = document.createElement('div');
      note.dataset.awEcosystemAtelierRelationStatus = 'true';
      note.className = 'aw-ecosystem-p1-service-note';
      root.querySelector('#aw-atelier-prestations')?.prepend(note);
    }
    if (!note) return;
    if (!handles.length) {
      note.textContent = 'Réplique active reconnue dans la base technique AW. Aucune prestation spécifique n’est actuellement enregistrée pour ce modèle exact ; vérifiez le périmètre avant intervention.';
      return;
    }
    const visibleHandles = new Set(Array.from(root.querySelectorAll('#aw-atelier-prestations a[href*="/products/"]')).map((link) => {
      try { return normalize(new URL(link.href, location.origin).pathname.match(/^\/products\/([^/?#]+)/i)?.[1] || ''); }
      catch (_) { return ''; }
    }).filter(Boolean));
    const visible = handles.filter((handle) => visibleHandles.has(normalize(handle))).length;
    note.textContent = `${handles.length} prestation${handles.length > 1 ? 's' : ''} Atelier explicitement liée${handles.length > 1 ? 's' : ''} à ce modèle exact dans Shopify · ${visible} affichée${visible > 1 ? 's' : ''} dans les prestations cœur de cette page. Les relations exactes restent prioritaires sur tout fallback par type.`;
  };

  const renderCompatibilityCopy = () => {
    const { technical, dedicated } = counts();
    document.querySelectorAll('[data-aw-compatibility-search]').forEach((root) => {
      const directory = root.querySelector('.aw-compatibility-search__directory');
      if (directory) {
        setText(directory.querySelector('.aw-compatibility-search__section-heading h2'), `${dedicated} fiches Compatibility dédiées`);
        setText(directory.querySelector('.aw-compatibility-search__section-heading > span'), `${dedicated} fiches dédiées`);
        setText(directory.querySelector('.aw-compatibility-search__directory-intro'), `${dedicated} modèles disposent d’une fiche dédiée. La recherche technique exploite ${technical} profils exacts AW quand leurs données sont disponibles.`);
      }

      const identity = root.querySelector('.aw-compatibility-search__identity');
      if (!identity || identity.closest('[hidden]')) return;
      const record = currentExactRecord();
      let note = identity.querySelector('[data-aw-ecosystem-workshop-summary]');
      if (!record) { note?.remove(); return; }
      if (!note) {
        note = document.createElement('p');
        note.dataset.awEcosystemWorkshopSummary = 'true';
        note.className = 'aw-ecosystem-p1-service-note';
        identity.append(note);
      }
      const count = Array.isArray(record.workshopServices) ? record.workshopServices.length : 0;
      note.textContent = count
        ? `Atelier AW : ${count} prestation${count > 1 ? 's' : ''} explicitement liée${count > 1 ? 's' : ''} à ce modèle exact dans Shopify. Vérifiez le périmètre avant intervention.`
        : 'Atelier AW : aucune prestation spécifique n’est actuellement enregistrée pour ce modèle exact. Un contrôle Atelier reste possible avant intervention.';
    });
  };

  const renderSeoDirectoryCopy = () => {
    const { technical, dedicated } = counts();
    const shell = document.querySelector('.aw14-model-directory');
    if (!shell) return;
    const head = shell.querySelector('.aw14-model-directory__head');
    if (head) {
      setText(head.querySelector('.aw14-eyebrow'), 'FICHES COMPATIBILITY DÉDIÉES');
      setText(head.querySelector('h2'), `${dedicated} fiches dédiées par modèle`);
      setText(head.querySelector('p:last-child'), `Ces ${dedicated} pages éditoriales sont distinctes de la base technique AW, qui contient ${technical} profils exacts utilisables par la recherche lorsqu’ils sont suffisamment renseignés.`);
    }
    const toggle = shell.querySelector('.aw-tools-seo-model-toggle');
    if (toggle && shell.querySelector('.aw14-model-directory__grid')?.hidden) setText(toggle, `Afficher les ${dedicated} fiches par familles`);
  };

  let pending = false;
  const render = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      renderMonAtelierStatus();
      enforceAtelierExactPriority();
      renderAtelierRelationStatus();
      renderCompatibilityCopy();
      renderSeoDirectoryCopy();
    });
  };

  if ('MutationObserver' in window) new MutationObserver(render).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('aw:context-changed', render);
  window.addEventListener('aw:garage-context-changed', render);
  window.addEventListener('aw:p2-garage-updated', render);
  document.addEventListener('shopify:section:load', render);
  window.AWEcosystemP1Copy = { version: '1.1.1', render, counts, currentExactRecord, renderMonAtelierStatus, enforceAtelierExactPriority, renderAtelierRelationStatus };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, { once: true });
  else render();
})();
